export default __webpack_public_path__ + "static/HassanBazar-aa7c43eb4af4c52ff33189d7a67f3d98.png";